import { Paragraph } from "@/components/ui/typography/Paragraph";

interface SidebarLinkProps {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  href: string;
}

export const SidebarLinkItem = ({ Icon, label, href }: SidebarLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center space-x-2 p-2 rounded-md min-w-full cursor-pointer hover:bg-neutral-100"
    >
      <Icon className="text-black" />
      <Paragraph>{label}</Paragraph>
    </a>
  );
};
